import styled from 'styled-components';

export const AboutBody = styled.div`
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
`;

export const AboutP = styled.p`
  font-size: 1.15rem;
  color: var(--text);
  line-height: 1.75;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FactsRow = styled.div`
  margin-top: 48px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Fact = styled.div`
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 22px 18px;
`;

export const FactLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 8px;
`;

export const FactValue = styled.div`
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--ink);
`;
